import { render, staticRenderFns } from "./order-listing-mob.vue?vue&type=template&id=7b396bd5&"
import script from "./order-listing-mob.vue?vue&type=script&lang=js&"
export * from "./order-listing-mob.vue?vue&type=script&lang=js&"
import style0 from "./order-listing-mob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VIcon,VSheet})
